import { useContext, useEffect, useRef, useState } from "react";
import { FaBell, FaSignOutAlt } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip"; // Importer le composant Tooltip
import { AuthContext } from "../../00-MAIN/00-CONTEXT/AuthContext";

function TopBar() {
  const { user, logout, isProfileIncomplete } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Hook pour récupérer l'URL actuelle
  const menuRef = useRef(null); // Référence pour le menu popup

  // Objet avec les titres des pages en fonction de l'URL
  const pageTitles = {
    "/home": "Accueil",
    "/account": "Mon compte",
    "/espace-personnel": "Espace Personnel",
    "/espace-patrimoine": "Espace Patrimoine",
    "/settings": "Paramètres",
    "/dashboard": "Tableau de bord",
    "/school": "School"
    // Ajoutez ici d'autres routes et titres selon votre besoin
  };

  // Récupérer le titre en fonction de la route actuelle
  const pageTitle = pageTitles[location.pathname] || "Page non trouvée"; // Titre par défaut si la route n'est pas trouvée

  const initials =
    (user && user.prenom ? user.prenom[0].toUpperCase() : "?") +
    (user && user.nom ? user.nom[0].toUpperCase() : "?");

  const handleLogout = async () => {
    localStorage.removeItem("access_token");
    logout();
    navigate("/login");
  };

  // Gestionnaire pour fermer le menu quand on clique à l'extérieur
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }

    // Ajouter l'écouteur d'événement si le menu est ouvert
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Nettoyer l'écouteur d'événement lors du démontage du composant
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]); // Dépendance à menuOpen pour n'ajouter l'écouteur que si le menu est ouvert

  return (
    <div className="w-full h-10 bg-white flex items-center justify-between px-6 border-b border-gray-300 shadow-sm">
      {/* Titre de la page */}
      <div className="text-lg font-semibold text-[#1F3B3B]">
        {pageTitle} {/* Titre dynamique en fonction de la route */}
      </div>

      {/* Icône notifications + avatar */}
      <div className="flex items-center space-x-6">
        <button
          className="relative text-gray-600 hover:text-gray-800 focus:outline-none"
          onClick={() => alert("Notifications non implémentées")}
        >
          <FaBell size={18} />
        </button>
        <div className="relative" ref={menuRef}>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="flex items-center justify-center w-8 h-8 rounded-full bg-[#00675A] text-white font-bold focus:outline-none"
            data-tooltip={isProfileIncomplete ? "Complétez votre profil" : ""} // Affichage de l'info-bulle si le profil est incomplet
            data-tooltip-position="top"
          >
            {initials}
          </button>
          {isProfileIncomplete && <Tooltip id="profileTooltip" />}
          {menuOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded shadow-lg py-2 z-10">
              <div className="px-4 py-2 text-gray-700 text-sm">
                Bonjour {user?.prenom || "Utilisateur"} !
              </div>
              <hr className="my-1" />
              <button
                onClick={() => navigate("/account")}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                Mon compte
              </button>
              <button
                onClick={handleLogout}
                className="flex items-center w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
              >
                <FaSignOutAlt size={16} className="mr-2" />
                Se déconnecter
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TopBar;